import React, { useState, useEffect } from "react";
import { Instagram, X } from "lucide-react";

export default function FloatingInstagram() {
  const [open, setOpen] = useState(true);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
    // setVisible is stable; t is defined inline — mount-only effect.
  }, []);

  if (!visible || !open) return null;

  return (
    <a
      href="https://instagram.com/knightinsurancesolutions"
      target="_blank"
      rel="noreferrer noopener"
      className="kn-ig-pill fixed bottom-24 lg:bottom-6 left-6 z-50 inline-flex items-center gap-3 pl-2 pr-3 py-2 rounded-full text-white shadow-2xl hover:scale-[1.03] active:scale-95 transition-transform"
      data-testid="floating-ig-toggle"
      style={{ textDecoration: "none" }}
    >
      <span className="flex items-center justify-center w-9 h-9 rounded-full bg-white/15 backdrop-blur">
        <Instagram size={18} />
      </span>
      <span className="font-semibold text-[14px] tracking-tight whitespace-nowrap">
        Follow us on Instagram&nbsp;
        <span className="opacity-95">@knightinsurancesolutions</span>
      </span>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(false);
        }}
        aria-label="Close"
        className="ml-1 w-7 h-7 rounded-full bg-white/20 hover:bg-white/35 transition-colors flex items-center justify-center"
        data-testid="floating-ig-close"
      >
        <X size={14} />
      </button>
    </a>
  );
}
